<template>
  <div>
    <LoadingState
      v-if="!taxonomyLoaded"
      :loading="!taxonomyLoaded"
      color="primary"
    />
    <Taxonomy
      v-if="taxonomyLoaded"
      :taxonomy="taxonomy"
      :taxonomy-breadcrumbs="taxonomyBreadcrumbs"
    />
  </div>
</template>

<script>
import Taxonomy from '../components/TaxonomySingle'
import LoadingState from '@/components/LoadingState'

export default {
  name: 'SingleTaxonomy',

  components: {
    Taxonomy,
    LoadingState
  },

  async beforeRouteLeave (to, from, next) {
    if (this.taxonomy && this.taxonomy.isDirty()) {
      const answer = await this.$root.$confirm(this.$t('Attention'), this.$t('You have unsaved changes. Are you sure want to leave?'), { color: 'primary' })

      if (answer) {
        this.taxonomy.reset()
      }

      return next(answer)
    }
    next()
  },

  actionBar () {
    return {
      title: 'Taxonomy',
      actions: [
        {
          text: '',
          event: 'save',
          disabled: true
        },
        {
          color: 'error',
          text: 'Delete',
          event: 'delete',
          disabled: true
        }
      ]
    }
  },

  data () {
    return {
      taxonomy: this.$http.make('taxonomy'),
      taxonomyLoaded: false
    }
  },

  computed: {
    isCreate () {
      return this.$route.params.id === '__'
    },

    saveActionStates () {
      return {
        disabled: !this.taxonomy || this.taxonomy.inProgress || this.taxonomy.errors.length,
        loading: this.taxonomy && this.taxonomy.inProgress
      }
    },

    deleteActionStates () {
      return {
        disabled: !this.taxonomy || this.taxonomy.inProgress,
        hidden: this.isCreate
      }
    },

    taxonomyBreadcrumbs () {
      return this.buildFullTaxonomy(this.taxonomy)
    }
  },

  async mounted () {
    this.init()
  },

  methods: {
    async init () {
      this.$radio.$emit('action-panel-actions-update', { event: 'save', action: { text: this.isCreate ? 'Create' : 'Save' } })

      try {
        this.taxonomy = this.isCreate ? await this.$http.make('taxonomy')
          : await this.$http.taxonomy.include(['parent', 'children', 'products']).find(`${this.$route.params.id}`)
        this.taxonomyLoaded = true
      } catch (e) {
        this.$toast.error(this.$t(e.message))
      }

      if (this.isCreate) {
        this.$radio.$emit('action-panel-title', 'New Taxonomy')
      } else {
        this.$radio.$emit('action-panel-title', this.taxonomy.name)
      }
    },

    buildFullTaxonomy (root) {
      root.fullTaxonomy = []
      this.getParentsRecursivelly(root.fullTaxonomy, root)
      root.fullTaxonomy.reverse()
      root.fullTaxonomy.push({
        text: root.name,
        disabled: true,
        href: null
      })

      return root.fullTaxonomy
    },

    getParentsRecursivelly (taxonomy, item) {
      if (!item.parent) {
        return
      }
      taxonomy.push({
        text: item.parent.name,
        disabled: false,
        href: item.parent.id
      })
      this.getParentsRecursivelly(taxonomy, item.parent)
    },

    goBack () {
      this.$router.push({ name: 'taxonomy' })
    },

    async onActionSave () {
      try {
        if (this.taxonomy.products) {
          this.taxonomy.product_ids = this.taxonomy.products.map(item => item.id)
        }

        if (this.taxonomy.children) {
          this.taxonomy.children_ids = this.taxonomy.children.map(item => typeof item === 'object' ? item.id : item)
        }

        await this.taxonomy.save()
        this.$toast.success(this.$t('Taxonomy saved'))

        if (this.isCreate) {
          this.$router.replace({
            name: 'single-taxonomy',
            params: { id: this.taxonomy.id }
          })
          this.init()
        }
      } catch (e) {
        this.$toast.error(this.$t(e.message))
      }
    },

    async onActionDelete () {
      if (!await this.$root.$confirm('Danger Zone', 'Please Confirm', { color: 'red' })) {
        return
      }
      await this.taxonomy.delete()
      this.$router.replace({
        name: 'taxonomy'
      })
    }
  }
}
</script>
